<template>
  <div>
    <!-- <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    /> -->
    <div class="payMain">
      <div class="pay-one">
        <div class="crile">
          <div v-if="orderPayList.mealType == 3">{{ $t('payOrderSuccess') }}</div>
          <div v-else style="text-align: center">
            <div ref="qrCode" class="qrCode"></div>
            <div style="font-size: 15px">{{ orderPayList.mealTakingNum }}</div>
          </div>
        </div>

        <div class="pay-one-text" v-if="orderPayList.mealType == 3">
          <!-- <div>配送时间：{{ orderPayList.targetDate }}</div> -->
          <div>{{ $t('appointmentTime') }}：{{ orderPayList.createTime }}</div>
          <div>{{ $t('paySuccessTip2') }}</div>
        </div>
        <div class="pay-one-text" v-else>
          <div>{{ $t('paySuccessTip') }}</div>
          <div>{{ orderPayList.branchName }}</div>
          <div>{{ $t('paySuccessTip2') }}</div>
        </div>
      </div>

      <div class="pay-two">
        <div>{{ $t('orderNo') }}：{{ orderPayList.orderNo }}</div>
        <div>{{ $t('paySuccessReserveTime') }}：{{ orderPayList.targetDate }}</div>
        <div>{{ $t('payTotalFee') }}：￥{{ (orderPayList.realFee / 100).toFixed(2) }}</div>
      </div>

      <div class="banner">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="item in bannerList" :key="item.id">
            <img :src="item.url" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="pay-btn">
        <div>
          <van-button type="info" @click="handleContinue">{{ $t('continueOrder') }}</van-button>
          <van-button type="info" @click="handleLookOrder">{{ $t('viewDetail') }}</van-button>
        </div>
        <div>{{ $t('scrollDeliciousBottom') }}~</div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      bannerList: [
        {
          url: "https://boc.yunpengai.com/img/20200409223976747674.jpg",
          id: 0,
        },
        {
          url: "https://boc.yunpengai.com/img/hb1.jpg",
          id: 2,
        },
        {
          url: "https://boc.yunpengai.com/img/hb2.jpg",
          id: 1,
        },
        {
          url: "https://boc.yunpengai.com/img/hb3.jpg",
          id: 3,
        },
      ],
      orderPayList: {},
      shopId: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/order/detail") {
      return next("/card/package?type=1");
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/card/package") {
      this.$vnode.parent.componentInstance.cache = {};
      this.$vnode.parent.componentInstance.keys = [];
    }
    next();
  },
  created() {},
  activated() {
    this.shopId = localStorage.getItem("shopId");
    this.getPayList();
  },
  mounted() {
    
  },
  methods: {
    handleCreateQrcode() {
      new QRCode(this.$refs.qrCode, {
        text: `H${this.orderPayList.orderNo}`,
        width: 100,
        height: 100,
      });
    },
    getPayList() {
      let data = {
        orderNO: this.$route.query.orderNo,
        shopId: this.shopId,
      };
      this.$authAjax
        .post("/api/wxapp/reserve/findOrderDetail", data)
        .then((res) => {
          let { data } = res.data;
          this.orderPayList = data;
          this.handleCreateQrcode();
        });
    },
    //查看订单
    handleLookOrder() {
      this.$router.replace({
        path: "/order/detail",
        query: {
          orderNo: this.$route.query.orderNo,
        },
      });
    },
    //继续点餐
    handleContinue() {
      this.$router.back()
    },
  },
};
</script>

<style lang="scss" scoped>
.payMain {
  width: 100%;
  height: 100vh;
  background: #f2f2f2;
  // margin-top: 45px;
  box-sizing: border-box;
  overflow: auto;
  padding: 0 14px;
  .pay-one {
    height: 170px;
    position: relative;
    background: #ffffff;
    border-radius: 8px;
    margin-top: 91px;
    .crile {
      width: 126px;
      min-height: 126px;
      border-radius: 10px;
      padding-top: 6px;
      background: linear-gradient(45deg, #2ab1e7, #8ddeff);
      box-shadow: 0 0 20px 4px #8ddeff;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      div {
        font-size: 24px;
      }
    }
    .pay-one-text {
      display: flex;
      flex-direction: column;
      text-align: center;
      position: absolute;
      bottom: 0;
      width: 100%;
      div:nth-child(1) {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      div:nth-child(2) {
        color: #666666;
        font-size: 14px;
        margin-bottom: 14px;
      }
      div:nth-child(3) {
        color: #999999;
        font-size: 12px;
        margin-bottom: 11px;
      }
    }
  }
  .pay-two {
    background: #ffffff;
    margin-top: 10px;
    padding: 16px 0 16px 14px;
    display: flex;
    flex-direction: column;
    color: #333333;
    font-size: 12px;
    border-radius: 8px;
    div:nth-child(1) {
      margin-bottom: 10px;
    }
    div:nth-child(2) {
      margin-bottom: 10px;
    }
  }

  .banner {
    height: 150px;
    width: 342px;
    margin-top: 10px;
    img {
      height: 150px;
      width: 342px;
    }
  }

  .pay-btn {
    text-align: center;
    color: #999999;
    font-size: 12px;
    margin-top: 30px;
    div:nth-child(1) {
      display: flex;
      justify-content: space-around;
      margin-bottom: 16px;
    }
  }
}
</style>
